var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 1.25c.928 0 2.15.02 3.136.122.354.037.684.063.984.186l.212.101c.479.266.848.722 1 1.25.092.311.084.652.084 1.026a.75.75 0 0 1-1.5 0c0-.47-.007-.55-.024-.608a.62.62 0 0 0-.34-.38c-.054-.022-.127-.038-.57-.084a27 27 0 0 0-2.232-.108V13.25H10a.75.75 0 1 1 0 1.5H6a.75.75 0 0 1 0-1.5h1.25V2.755c-.75.01-1.56.04-2.233.108-.444.046-.516.061-.569.083a.62.62 0 0 0-.342.381c-.016.057-.023.14-.023.608a.75.75 0 0 1-1.5 0c0-.374-.007-.715.084-1.027a2.12 2.12 0 0 1 1.212-1.35c.3-.124.63-.15.985-.186C5.851 1.271 7.072 1.25 8 1.25"
  })));
};
export default Svg16;